var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"w-full h-full",staticStyle:{"border":"0"},attrs:{"loading":"lazy","referrerpolicy":"no-referrer-when-downgrade","src":_vm.embedSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }